import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchPrograms from 'src/components/Browse/SearchPrograms';
import { useSelectedPrograms } from '@unite-us/app-search';

function MyNetworkPrograms({
  params: { networkId },
  networks,
  ...otherProps
}) {
  const { dispatchRemoveAllPrograms } = useSelectedPrograms();
  const [pageNetworkId, setPageNetworkId] = useState(networkId);

  useEffect(() => dispatchRemoveAllPrograms(), []);

  useEffect(() => {
    setPageNetworkId(networks);
  }, [networks]);

  if (!pageNetworkId) return null;

  return (
    <div className="bg-medium-fill-blue">
      <SearchPrograms
        {...otherProps}
        networkId={pageNetworkId}
      />
    </div>
  );
}

MyNetworkPrograms.propTypes = {
  params: PropTypes.shape({
    networkId: PropTypes.string,
  }),
  networks: PropTypes.string.isRequired,
};

MyNetworkPrograms.defaultProps = {
  params: {
    networkId: '',
  },
};

function mapStateToProps(state) {
  const networks = state.globalState.activeNetworks.map((n) => n.id).join(',');

  return {
    networks,
  };
}

export default connect(mapStateToProps)(MyNetworkPrograms);
